import React from 'react';
import projectImage from '../img/U1.png';
import Navbar from './Navbar';
import { motion } from "framer-motion";
import { FaGithub, FaFigma } from "react-icons/fa";
import { Link } from "react-router-dom";

const Project = () => {
  return (
    <div>
      <Navbar />

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5 }}
        id='about'
        className="mx-auto px-4 md:px-20"
      >
        <h2 className="text-4xl sm:text-4xl font-bold pl-4 pt-20">Project Title : Company Management System UI/UX</h2>

        <div className="max-w-screen-lg mx-auto grid grid-cols-1 md:grid-cols-2 gap-4 items-center justify-center h-full py-10">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.5 }}
            className="h-75 w-75 ml-4 mr-4 pr-4"
          >
            <img
              src={projectImage}
              alt="Project Screenshot"
              className="mx-auto w-full shadow-2xl"
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.5 }}
            className="flex flex-col justify-center h-full   "
          >
            <div className="items-center justify-center">
              <h2 className="text-3xl sm:text-4xl font-bold pl-4">Key tools and technologies:</h2>
              <ul className="flex flex-wrap justify-center pb-5 text-xl sm:text-2xl font-bold pt-2">
              <li className="pl-10">Figma</li>
              </ul>
            </div>

            <div className="items-center justify-center">
              <ul className="flex justify-center pb-5 text-xl sm:text-2xl font-bold">
                <li className="pl-4">
                <Link to="https://www.figma.com/file/dDhtYTjFuz5UsEMUjetz3P/PayRoll?type=design&node-id=0-1&mode=design&t=kT4o0igFHC6pi18c-0">
                      <FaFigma size="3.3rem" />
                    </Link>              </li>
               
              </ul>
            </div>
          </motion.div>
        </div>

        <h1 className="text-4xl sm:text-3xl font-bold pt-10 pl-4">Project Description:</h1>
        <div className="px-4 md:px-20">
          <p className="py-4">
          As a UI/UX developer, I am working on an innovative Payroll System, specifically focusing on building an Employee Management System. This comprehensive system is designed to streamline and optimize the management of employee data, ensuring efficient and effective workforce management.

<br/>The Employee Management System offers a wide range of essential features, empowering HR teams and managers to maintain and organize employee information seamlessly. This includes capturing personal details, bank information, and working hours, providing a centralized database for all essential employee records.

<br/>Additionally, the system offers a comprehensive performance analysis for each employee, displayed in intuitive and visually appealing graphs. These graphs allow employees to easily comprehend and track their individual performance metrics, fostering a sense of empowerment and ownership of their work.

<br/>For enhanced project management, the system incorporates a task list that outlines assigned projects and their respective completion dates. This ensures clarity and accountability, facilitating smooth project execution and timely deliverables.

<br/>Moreover, the Payroll System offers a detailed salary graph, presenting a clear visualization of each employee's salary history. This transparency cultivates a sense of trust and satisfaction among employees, as they can review their financial growth within the organization.

 </p>

          {/* <div>
            <button
              type="button"
              className="text-white bg-gradient-to-r from-cyan-400 via-cyan-500 to-cyan-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-cyan-300 dark:focus:ring-cyan-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2"
            >
              Video Link
            </button>
          </div> */}
        </div>
      </motion.div>
    </div>
  );
};

export default Project;
